import type { SessionOptionPricesRequest, SessionOptionPricesResponse } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { ComputedRef, Ref } from "vue";
import { computed } from "vue";
import { learningServiceRequest } from "@/services/utils";

interface Args<TData = SessionOptionPricesResponse> {
  request: ComputedRef<SessionOptionPricesRequest>;
  useQueryOptions?: Partial<UseQueryOptions<SessionOptionPricesResponse, Error, TData>>;
  get_active?: Ref<boolean>;
}

export const sessionPriceQueryKey = (payload: SessionOptionPricesRequest) => ["getSessionPricing", payload];

export const useGetSessionPricing = <TData = SessionOptionPricesResponse>({
  request: payload,
  useQueryOptions,
  get_active,
}: Args<TData>) => {
  const getSessionPricing = async (): Promise<SessionOptionPricesResponse> => {
    return await learningServiceRequest({
      method: "post",
      url: "/programming/sessions/pricing",
      failureMessage: "Error loading program session pricing",
      payload: payload.value,
      params: {
        get_active: get_active?.value,
      },
    }).then((response) => response?.data);
  };

  return useQuery<SessionOptionPricesResponse, Error, TData>({
    queryKey: computed(() => sessionPriceQueryKey(payload.value)),
    queryFn: getSessionPricing,
    ...useQueryOptions,
  });
};
